// extracted by mini-css-extract-plugin
export default {"borderBoxStyle":"technicalSummaryTab_borderBoxStyle__kYFet","imageBoxStyle":"technicalSummaryTab_imageBoxStyle__hqC-e"};